<template>
  <div class="process_explain">
    <div class="tit">
      <span>
        <router-link
          to="/personal_center/enterprise/property_services/pass/table_list"
          class="back"
        >
          <i class="el-icon-arrow-left"></i>
        </router-link>物品放行申请详细流程
      </span>
    </div>
    <div class="pd20">
      <div  class="ck-text" v-html="content"></div>
    </div>
    <!-- <div class="m1">
      <div class="h3">办理须知</div>
      <div class="p">1.《搬出物品放行条》需加盖公章，正确填写合同房号、经办人、联系手机和物品清单。</div>
      <div class="p">2. 撤离园区的企业应办理完退租手续并缴清相关费用，经审批后方可放行物品。</div>
      <div class="p">3. 有欠缴费用的一般不予签发物品放行，特殊情况除外。</div>
    </div>
    <div class="m3">
      <div class="h3">业务办理地点</div>
      <div class="h4">A幢701单元（1#、2#电梯）</div>
    </div>
    <div class="m3">
      <div class="h3">业务办理时间</div>
      <div class="h4">工作日09:00~11:00，14:00~16:30</div>
      <div class="h4">（12:00~14:30禁止噪音施工）</div>
    </div>
    <div class="m3">
      <div class="h3">业务联系人</div>
      <div class="h4">联系人：张先生</div>
      <div class="h4">
        办公电话：
        <span class="phone_href" data-mobile="02032068333" bindtap="callNUm">32068333</span>转分机209
      </div>
      <div class="h4">
        手机：
        <span class="phone_href" data-mobile="13710332678" bindtap="callNUm">13710332678</span>
      </div>
    </div>
    <div class="m2">
      <div class="h3">业务办理须知</div>
      <div class="list mt20">
        <div class="title2">线上预约</div>
        <div class="content">经办人通过小程序预约，填写相关信息及预约线下审批时间。</div>
      </div>
      <div class="list">
        <div class="title2">预约预审批</div>
        <div class="content">园区管理员预审批，并反馈可以到业务办公室办理审批单签字的时间。</div>
      </div>
      <div class="list">
        <div class="title2">填写放行条</div>
        <div class="content">预审批通过后，经办人通过小程序下载《搬出物品放行条》电子文档，填写后打印并加盖公章。</div>
      </div>
      <div class="list">
        <div class="title2">线下审批</div>
        <div class="content">按照预约时间，经办人携带已盖企业公章的放行条前往业务办理地点进行现场签批。</div>
      </div>
      <div class="list last">
        <div class="title2">物品搬出</div>
        <div class="content">物品搬出时，经办人将已签名审批的放行条交给保安。经保安检查确认后放行。</div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data(){
    return {
      obj:{},
      content:''
    }
  },
  computed: {
    parkInfo(){
      return this.$store.state.parkInfo;
    },
  },
  created() {
    if(this.parkInfo){
      this.getIncubatorConfig();
    }else{
      this.needInfo('parkInfo','getIncubatorConfig');
    }
  },
  methods:{
     /* 监测信息 */
    needInfo(name,fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn] && this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    /** 须知*/
    getIncubatorConfig() {
      let params ={
        id:this.parkInfo.id,
      }
      this.api.getIncubatorConfig(params).then(res => {
        if (res.error["err_code"] !== 0) return;
         this.obj = JSON.parse(res.obj.business_info.extend6);//extend6 号码集合
         this.content = res.obj.business_info.extend2;//富文本
      });
    },
  }
};
</script>

<style lang="scss" scoped>
// .m1 {
//   padding: 12px 20px;
//   background: #f8f9fb
//     url("https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/tops/image/bg/bg1.png")
//     no-repeat center;
//   background-size: 100% 100%;
// }
// .h3 {
//   line-height: 38px;
//   height: 38px;
//   font-size: 14px;
//   font-weight: bold;
//   color: #343434;
// }
// .p {
//   font-size: 13px;
//   line-height: 20px;
//   color: #666;
// }
// .m2 {
//   background-color: #fff;
//   padding: 12px 20px;
// }
// .list {
//   border-left: 1px solid #eee;
//   padding: 0 0 20px 20px;
//   position: relative;
// }
// .list.last {
//   border: 0;
// }
// .list::after {
//   content: "";
//   width: 16px;
//   height: 16px;
//   background: #dedfe3;
//   border-radius: 50%;
//   position: absolute;
//   left: -8px;
//   top: 0;
// }
// .list .title2 {
//   font-size: 14px;
//   font-weight: bold;
//   color: #343434;
//   position: relative;
// }
// .list .content {
//   font-size: 12px;
//   color: #9a9a9a;
//   line-height: 18px;
//   margin-top: 15px;
// }
// .m3 {
//   background-color: #fff;
//   padding: 13px 20px 13px;
// }
// .h4 {
//   font-size: 13px;
//   color: #343434;
//   line-height: 20px;
// }
.tit {
  .back {
    display: inline-block;
    width: 38px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border: 1px solid #dcdfe6;
    margin-right: 14px;
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>